<!-----------------------------------------------------------------------------
  - Copyright (c) 2018. keni <$email>                                         -
  -                                                                           -
  - This file global-search.vue is part of event_pass_client.dev.             -
  - Unauthorized copying of this file, via any medium is strictly prohibited. -
  - Proprietary and confidential                                              -
  - global-search.vue can not be copied and/or distributed                    -
  - without the express permission of keni                                    -
  ----------------------------------------------------------------------------->

<template>
    <section class="global-search"
            data-component="global_search_component"
            ref="GlobalSearch"
    >
        <div class="mb-0 form-inline md-form form-sm global-search--element"

        >

            <input :id="searchInputId"
                   data-ref="searchInput"
                    class="main-nav-global--search-vuejs--input float-right d-block global-search--element-input watch-transition--slow form-control mb-0 mt-0"
                    :class="setInputClass()"
                    type="search"
                    v-model="searchString"
                    :placeholder="(typeof no_placeholder === 'undefined') && params.search.placeholder" :aria-label="(typeof no_placeholder !== 'undefined' && no_placeholder !== null) && (no_placeholder == true) && params.search.placeholder"
                    title="search--input"
            >
            <i :id="searchIconId"
               data-ref="searchIcon"
                    class="main-nav-global--search-vuejs--icon float-right d-block material-icons cursor-pointer w-10 watch-transition--fast"
                    :class="{
                        'active':isActive
                    }"
                    aria-hidden="true"
                    v-on:click="activateSearch($event)"
            >search</i>
        </div>


        <!--Results Display-->
        <div>
            <transition-group v-if="filteredResults.length > 0" tag="ul" class="z-depth-2 global-search-results" name="article">
                <!-- Render a li element for every entry in the computed filteredArticles array. -->
                <li class="global-search-results--list"
                        :tabindex="index"
                        v-for="(result,index) in filteredResults"
                        :key="result.key"
                >

                    <a v-if="result.id != null" :href="result.url" class="global-search-results--list-item">
                        <!--<img :src="tag[path.data].images[0]" alt="">-->
                        <span v-html="result.lang[params.lang].title"></span>
                        <span v-if="result.start_date !== null && result.start_date !== undefined"> - {{new Date(result.start_date.date).getFullYear()}}</span>
                    </a>

                    <div v-else class="global-search-results--list-spacer w-100 py-2 m-0">
                        <div class="mt-1 divider-new divider-new-with-substring">
                            {{result.spacer}}
                        </div>
                    </div>
                </li>
            </transition-group>

            <ul v-else-if="searching" class="global-search-results">
                <!-- Render a li element for every entry in the computed filteredArticles array. -->
                <li class="global-search-results--list">

                    <a class="global-search-results--list-item">
                        <!--<img :src="tag[path.data].images[0]" alt="">-->
                        <span>Searching...</span>
                    </a>
                </li>
            </ul>

            <ul v-else-if="!first_search" class="global-search-results">
                <!-- Render a li element for every entry in the computed filteredArticles array. -->
                <li class="global-search-results--list">

                    <a class="global-search-results--list-item">
                        <!--<img :src="tag[path.data].images[0]" alt="">-->
                        <span>No results...</span>
                    </a>
                </li>
            </ul>
        </div>

    </section>
</template>

<script>
	import axios from 'axios';
	import {_} from 'underscore'

	//ADD JSDOC HERE!!!!!
	export default {
		props: ['content','no_placeholder'],
		components: {axios},
		created() {
			let _self = this;

			_self.params = _.extendOwn(_self.params, this.content);

			// load all tags
			// this.tags = this.readDataSet();
			document.addEventListener('click', this.documentClick);
			document.addEventListener("keydown", this.documentKeyDown);
			// console.log('created', 'this.no_placeholder',this.no_placeholder);
		},

		destroyed() {
			document.removeEventListener('click', this.documentClick);
			document.removeEventListener("keydown", this.documentKeyDown);
		},
		data() {
			return {
				searchIconId: _.uniqueId('global-search--icon-id--'),
				searchInputId: _.uniqueId('global-search--input-id--'),
				filteredResults: [],
				searchString: '',

				de_bounce_timer: null,
				first_search: true,
				searching: false,
				loading_results: false,
				reDoSearch: false,
				isActive: false,

				params: {
					no_border:false,
					url: {},
					search: {
						searchLength: 1,
						placeholder: 'Search',
						colorClass: 'black-text'
					},
					de_bounce_time_ms: 300,
					path: {
						data: 'tag_data'
					},
					lang: 'en_GB',
				},

			}
		},
		methods: {
			activateSearch(e) {
				let _self = this;
				// console.log('activateSearch', '_self.filteredResults',_self.filteredResults.length);
				this.isActive = !this.isActive;
				if (!this.isActive) {
					_self.clearSearch(e)
				}
				else {
					document.getElementById(this.searchInputId).focus();
				}
				this.$emit('searchActive', this.isActive)
			},
			setInputClass() {
				let activeClass = 'w-0',border='';

				if (this.isActive) {
					activeClass = 'w-90';
				}
				if(this.params.no_border){
					border = 'border-bottom-0 '
                }
				return `${activeClass} ${border} ${this.params.search.colorClass}`;
			},
			executeSearch() {
				let
					_self = this;

				_self.filteredResults = [];
				_self.de_bounce_timer = null;

				_self.loading_results = true;
				// console.log('executeSearch', '_self.params.url', _self.params.url, 'self.searchString', _self.searchString);
				axios.get(_self.params.url + '?q=' + _self.searchString + '&l=10') //@todo change the length to a param
					.then(function (response) {
						_self.loading_results = false;
						_self.searching = false;

						if (_self.reDoSearch) {
							//The user typed something else
							//Let's redo the search without waiting for the de_bouncer
							_self.reDoSearch = false;
							_self.searching = true;
							_self.executeSearch();

							return;
						}
						else if (_self.searchString === '') {
							//user cleared out while recieving the response
							//so let's clear the search

							return;
						}
						else {
							//new search

							let key = 0;

							//Filtering and adding all events
							if (response.data._events_found > 0) {
								_self.filteredResults.push({
									id: null,
									spacer: 'events',
									key: key++
								});

								response.data.events.forEach(function (event) {
									let record = _self.formatResult(event);
									record.key = key++;

									_self.filteredResults.push(record);
								});
							}

							//Filtering and adding all teams
							if (response.data._teams_found > 0) {
								_self.filteredResults.push({
									id: null,
									spacer: 'teams',
									key: key++
								});

								response.data.teams.forEach(function (team) {
									let record = _self.formatResult(team);
									record.key = key++;

									_self.filteredResults.push(record);
								});
							}
						}
					})
			},

			formatResult(item) {
				let itemTitle = item.lang[this.params.lang].title,
					reg = new RegExp(this.searchString, 'g'),
					compile = `<span class="font-weight-bold">${this.searchString}</span>`;

				itemTitle = itemTitle.replace(reg, compile);
				item.lang[this.params.lang].title = itemTitle;

				return item;
			},
			clearSearch(e) {
				this.searchString = '';
				let el = this.$refs.GlobalSearch,
					isTarget = (el === e.target),
					contains = el.contains(e.target);

				if (!isTarget && !contains) {
					this.searchString = '';
				}

				this.first_search = true;
			},

			/**
			 * processes clicks on document
			 * @param e
			 */
			documentClick(e) {
				// console.log('documentClick', 'e',e,'e.target',e.target);
				if (e.target.getAttribute('id') == this.searchIconId) {
					return false;
				}

				this.clearSearch(e);
			},
			/**
			 * processes keydown events
			 * @param e
			 */
			documentKeyDown(e) {
				//escape key pressed
				if (e.keyCode === 27) {
					this.searchString = '';
				}
			},
			prevent(e) {
				if (e) {
					e.preventDefault();
				}
			},
			applySearch() {
				if (this.searchString.trim() === '') {
					if (this.de_bounce_timer) {
						clearTimeout(this.de_bounce_timer);
					}

					this.first_search = true;
					this.searching = false;
					this.filteredResults = [];

					return;
				}

				this.searching = true;
				this.first_search = false;

				if (this.loading_results) {
					//One query is loading as of now, this will force to update when that pending one updates
					this.reDoSearch = true;
					return;
				}

				if (this.de_bounce_timer) {
					clearTimeout(this.de_bounce_timer);
				}

				this.de_bounce_timer = setTimeout(this.executeSearch, this.params.de_bounce_time_ms);
			}
		},
		watch: {
			searchString() {
				this.applySearch();
			}
		},
		computed: {
			filteredArticles: function () {
				let _self = this,
					articles_array = this.tags,
					searchString = this.searchString;

				// console.log('filter_stuff');

				return [];
			}
		}
	}
</script>
<style>
    .main-nav-global--search-vuejs--input{

    }
    .main-nav-global--search-vuejs--icon{
        font-size: 1.7rem !important;
        bottom: -22px;
    }
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 300px;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        /*color: #42b983;*/
    }

    .modal-body {
        margin: 20px 0;
    }

    .modal-default-button {
        float: right;
    }

    /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/front/search/global-search.vue